import { isMobileDevice } from "../components/Screen/Screen";

export type HorizontalAlignment = "center" | "left" | "right";

export type HorizontalAlignmentProp = {
  desktop: HorizontalAlignment;
  mobile: HorizontalAlignment;
};

export const getHorizontalAlignment = (
  bodyWidth: number,
  componentBounds: ClientRect,
  horizontalAlignment: HorizontalAlignmentProp,
  config: { [index: string]: any }
) => {
  const isMobile = isMobileDevice(config);

  if (isMobile) {
    switch (horizontalAlignment.mobile) {
      case "center":
        return bodyWidth / 2 - componentBounds.width / 2 + "px";

      case "left":
        return "0px";

      case "right":
        return bodyWidth - componentBounds.width + "px";

      default:
        return componentBounds.left + "px";
    }
  } else {
    switch (horizontalAlignment.desktop) {
      case "center":
        return bodyWidth / 2 - componentBounds.width / 2 + "px";

      case "left":
        return "0px";

      case "right":
        return bodyWidth - componentBounds.width + "px";

      default:
        return componentBounds.left + "px";
    }
  }
};
